import { AuthApi } from '../auth/authApi';
import { Singleton } from '@/decorators';
import type {
  GetSignatureRequestDTO,
  GetSignatureResponseDTO,
  GetUserFullNameRequestDTO,
  GetUserFullNameResponseDTO,
  GetSignatureNameRequestDTO,
  GetSignatureNameResponseDTO,
  UpdateSignatureRequestDTO,
  UpdateSignatureResponseDTO,
  UpdateSignatureNameRequestDTO,
  UpdateSignatureNameResponseDTO,
} from './DTOs';
import type { Result } from '@/types/result.interface';
import type { AppError } from '@/types/errors.interface';
import { wrapHttpCall } from '../utils/apiResultMapper';

/**
 * Signature API (Framework Agnostic)
 * 
 * Handles signature-related operations for application forms.
 */
@Singleton
export class SignatureApi extends AuthApi {
  constructor() {
    super();
  }

  async getUserFullName(body: GetUserFullNameRequestDTO): Promise<Result<GetUserFullNameResponseDTO, AppError>> {
    return wrapHttpCall(() => this.api.get<GetUserFullNameResponseDTO>(
      `/ApplicationForm/${body.applicationId}/fullName`,
    ));
  }

  async getSignature(body: GetSignatureRequestDTO): Promise<Result<GetSignatureResponseDTO, AppError>> {
    return wrapHttpCall(() => this.api.get<GetSignatureResponseDTO>(
      `/ApplicationForm/${body.applicationId}/signature`,
    ));
  }

  async updateSignature(body: UpdateSignatureRequestDTO): Promise<Result<UpdateSignatureResponseDTO, AppError>> {
    return wrapHttpCall(() => this.api.post<UpdateSignatureResponseDTO>(
      `/ApplicationForm/${body.applicationId}/signature`,
      body.signature,
    ));
  }

  async getSignatureName(
    body: GetSignatureNameRequestDTO,
  ): Promise<Result<GetSignatureNameResponseDTO, AppError>> {
    return wrapHttpCall(() =>
      this.api.get<GetSignatureNameResponseDTO>(
        `/ApplicationForm/${body.applicationId}/signatureName`,
      ),
    );
  }

  async updateSignatureName(
    body: UpdateSignatureNameRequestDTO,
  ): Promise<Result<UpdateSignatureNameResponseDTO, AppError>> {
    return wrapHttpCall(() =>
      this.api.post<UpdateSignatureNameResponseDTO>(
        `/ApplicationForm/${body.applicationId}/signatureName`,
        body.signatureName,
      ),
    );
  }
}
